export default {
	data() {
    return {
      appName: 'Cozy Taps',
      email: 'support@cozytaps.com'
    }
  },
}